import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";
import pathClubDetail from "./klub/routes-path";
import { ClubView } from "./klub/view";

class Kluby extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        const pathRedirect = "/";

        return <Switch>
            <Route path={pathClubDetail} render={(routeProps) => <ClubView />} />

            <Redirect to={pathRedirect} />
        </Switch>;

    }
}

export default withRouter(Kluby);